import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'

const VentilationSelection = (props) => {
    const t = useTranslate();

    const selectData = (ventilationType) => {
        if(props.selectionVentilation.includes(ventilationType)){
            //Retrait d'un ventilation
            props.setSelectionVentilation(props.selectionVentilation.filter(item => item!=ventilationType))
        }else{
            //Ajout
            if(ventilationType=='taxe' || ventilationType=='article'){
                let toDelete = ventilationType=='taxe' ? 'article' : 'taxe'
                let toAdd = ventilationType=='taxe' ? 'taxe' : 'article'

                let newData = false

                if(props.selectionVentilation.includes(toDelete)){
                    newData = props.selectionVentilation.filter(item => item!=toDelete)
                }else{
                    newData = props.selectionVentilation
                }

                props.setSelectionVentilation([...newData,toAdd])
            }else{
                props.setSelectionVentilation([...props.selectionVentilation,ventilationType])
            }
            
        }
    };

    return(
        <>
            <label className='fw-bold mb-2'>{t('selectionOfTheDataTypeToAssociate')}</label>
            <div className="d-flex justify-content-between mb-2">
                {Object.entries(props.ventilationInit).map(([key,traduction])=>{
                    return(
                        <div key={key} className="form-check form-switch">
                            <input checked={props.selectionVentilation.includes(key)} type="checkbox" className="form-check-input" onChange={()=>selectData(key)} />
                            <label title="" className="form-check-label">{traduction}</label>
                        </div>
                    )
                })}
            </div>
        </>
    )
}

export default VentilationSelection;